export const WAREHOUSES_FEATURE_KEY = 'warehouses';
